export const  API_VERSION_V1 = "/v1/";
export const  API_VERSION_V2 = "/v2/";
export const  API_VERSION_V3 = "/v3/";
